export enum UserReportStatusType {
    Pending,
    UnderReview,
    Resolved,
    Rejected
}

export function getUserReportStatusTypeToString(status: UserReportStatusType): string {
    switch (status) {
        case UserReportStatusType.Pending:
            return "Na čekanju";
        case UserReportStatusType.UnderReview:
            return "U pregledu";
        case UserReportStatusType.Resolved:
            return "Rešeno";
        case UserReportStatusType.Rejected:
            return "Odbijeno";
        default:
            return "Nepoznat status";
    }
}